<!--  FINANCE LOCKED  -->

<div class="written-content padded">
	<h3>Your finance application has been processed!</h3>
	<p>
		Your finance application has been submitted and any changes to the deal will invalidate your application.
	</p>
	<p>
		Do you want to invalidate your finance application and make changes to your deal?
	</p>
</div>

<!--  END FINANCE LOCKED  -->
